import { Validator } from './Validator';
import { ValidationError } from './ValidatorError';
export class ProcessContentAssistantValidator extends Validator {
    validate(model) {
        if (!model.text ||
            !model.outputVariable ||
            (parseInt(model.score) > 100 || parseInt(model.score) < 0)) {
            throw new ValidationError('Invalid parameters');
        }
    }
}
